<template>
  <vx-card>
    <vs-prompt
      title="Add User"
      accept-text="Save"
      @cancel="clearFields"
      @accept="saveData"
      @close="clearFields"
      :is-valid="validateForm"
      :active.sync="addPrompt"
    >
      <component
        :is="scrollbarTag"
        class="scroll-area p-4"
        :settings="settings"
        :key="$vs.rtl"
      >
        <h4 class="text-primary">Credentials</h4>

        <form @submit.prevent>
          <vs-input
            v-validate="'required|email'"
            data-vv-validate-on="blur"
            name="email"
            label="Email"
            v-model="email"
            class="w-full mb-2"
          />
          <span class="text-danger text-sm" v-show="errors.has('email')">
            {{ errors.first("email") }}
          </span>
          <vs-input
            type="password"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="password"
            label="Password"
            v-model="password"
            class="w-full mb-2"
          />
          <span class="text-danger text-sm" v-show="errors.has('password')">
            {{ errors.first("password") }}
          </span>

          <div class="form">
            <h4 class="text-primary">Permissions</h4>
            <DxTreeView
              id="treeview"
              :ref="treeViewRef"
              :width="340"
              :height="320"
              :items="permission_list"
              show-check-boxes-mode="normal"
              selection-mode="multiple"
              :select-nodes-recursive="true"
              :select-by-click="true"
              @selection-changed="treeViewSelectionChanged"
              @content-ready="treeViewContentReady"
            >
              <template #item="item">
                {{ item.data.label }}
              </template>
            </DxTreeView>
          </div>
        </form>
      </component>
    </vs-prompt>

    <vs-prompt
      title="Edit Permissions"
      class="export-options"
      @cancel="clearFields"
      @accept="updateData"
      accept-text="Update"
      @close="clearFields"
      :is-valid="at_least_one_permission"
      :active.sync="editPrompt"
    >
      <DxTreeView
        id="treeview"
        :ref="treeViewRef"
        :width="340"
        :height="320"
        :items="edited_permission_list"
        show-check-boxes-mode="normal"
        selection-mode="multiple"
        :select-nodes-recursive="true"
        :select-by-click="true"
        @selection-changed="treeViewSelectionChanged"
        @content-ready="treeViewContentReady"
      >
        <template #item="item">
          {{ item.data.label }}
        </template>
      </DxTreeView>
    </vs-prompt>

    <div class="export-table">
       <!-- <search-bar /> -->

      <vs-table :data="users">
        <template slot="header">
            <vs-button
              class="bg-primary-gradient py-4 mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/6   xl:w-1/6 "
              icon-pack="feather"
              icon="icon-plus"
              @click="addPrompt = true"
            >
              Add User
            </vs-button>

      <vs-input icon-no-border icon="icon-search" icon-pack="feather" class="mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 input-rounded-full"  v-model="searchQuery"/>

            <!-- ADD NEW -->


        </template>
        <template slot="thead">
          <vs-th>Email</vs-th>
          <vs-th>Permissions</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="w-12">{{ tr.email }}</vs-td>
            <vs-td>
              <template v-if="tr.permission">
                <div
                  v-for="(listItem, index) in tr.permission.permissions"
                  :key="index"
                >
                  <vs-chip
                    v-if="
                      listItem.selected &&
                      listItem.label != 'GeneratePaymentLink'
                    "
                    transparent
                    class="ag-grid-cell-chip"
                    color="primary"
                    v-model="listItem.selected"
                    >{{ listItem.label }}</vs-chip
                  >
                </div>
              </template>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(tr)"
              />
              <!-- <feather-icon icon="PlusIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="showData(tr.id)" /> -->
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="my-5">
        <vs-pagination
          v-if="total_items && !searchQuery"
          :total="total_pages"
          v-model="currentx"
        ></vs-pagination>
      </div>
    </div>
  </vx-card>
</template>
<script>
import { _sub_users } from "@/services/Company";
import { _save, _update, _delete, _filter } from "@/services/Subuser";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DxTreeView from "devextreme-vue/tree-view";


import { permission_list } from "./data.js";

const treeViewRef = "treeView";

export default {
  components: {
    VuePerfectScrollbar,
    DxTreeView,
  },
  computed: {
    treeView: function () {
      return this.$refs[treeViewRef].instance;
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.email != "" &&
        this.password != "" &&
        this.selectedPermission.length > 0
      );
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  watch: {
    currentx(val) {
      this.getSubusers(val);
    },
    "$store.state.company.companyID"(val) {
      this.current_company = val;
    },
    selectedPermission: {
      deep: true,
      handler() {
        this.at_least_one_permission = this.selectedPermission.length>0
      },
    },
    searchQuery(val){
      this.getSubusers();

    }
  },
  data() {
    return {
      searchQuery: "",
      permission_list,
      edited_permission_list: [],
      selectedPermission: [],
      treeViewRef,
      original_permissions : [],
      users: [],

      editedRow: "",
      permissions: [],

      addPrompt: false,
      editPrompt: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
      email: "",
      password: "",
      items_per_page: 1,
      total_items: 0,
      total_pages: 1,
      currentx: 1,
      current_company: this.$store.state.company.companyID,
      at_least_one_permission: null,
      deleteIndex: -1,
    };
  },
  beforeMount() {
    this.getSubusers();
  },
  mounted() {
    this.original_permissions = JSON.parse(JSON.stringify(this.permission_list)) ;
  },
  methods: {
    treeViewSelectionChanged(e) {
      this.syncSelection(e.component);
    },

    treeViewContentReady(e) {
      this.syncSelection(e.component);
    },

    syncSelection(treeView) {
      const selectedPermission = treeView
        .getSelectedNodes()
        .map((node) => node.itemData);

      this.selectedPermission = selectedPermission;
    },

    saveData() {
      let data = {
        email: this.email,
        password: this.password,
        permissions: this.selectedPermission.filter((p) => {
          if (p.id != "2" && p.id != "11") {
            return p;
          }
        }),
        company_id: this.current_company,
      };
      this.$vs.loading({ text: "Fetching data......" });
      _save(data)
        .then(
          (res) => {
            this.$vs.loading.close();
            this.users.push(res.data.obj);
          },
          (error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((error) => {
          this.handleCatch(error);
        })
        .finally(() => {
          this.$vs.loading.close();
          this.clearFields();
        });
    },
    editData(tr) {
      this.editedRow = tr;
      let arr = [];
      const tempObj = JSON.parse(JSON.stringify(tr.permission.permissions));

      this.permission_list.map((f, index) => {
        let g = f;
        if (f.items) {
          f.items.map((i, idx) => {
            let val2 = tempObj.find((p) => p.id === i.id);
            if (val2) {
              g.items[idx] = val2;
            }
          });
          arr[index] = g;
        } else {
          let val1 = tempObj.find((p) => p.id === f.id);
          if (val1) {
            arr[index] = val1;
          } else {
            arr[index] = f;
          }
        }
      });
      this.edited_permission_list = arr;
      this.editPrompt = true;
    },
    updateData() {
      this.$vs.loading();
      let user_id = this.editedRow.id;
      let localPermissions = this.selectedPermission.filter((p) => {
          if (p.id != "2" && p.id != "11") {
            return p;
          }
        });
      _update(user_id, { permissions: localPermissions }).then((res) => {
        this.$vs.loading.close();
        console.log(res.data);
        this.users = this.users.map((u) => {
          if (u.id == user_id) {
            return res.data.obj;
          }
          return u;
        });
      })
      .catch((error) => {
          this.handleCatch(error);
        })
        .finally(() => {
          this.$vs.loading.close();
          this.clearFields();
        });
    },

    deleteData(tr) {
      this.deleteIndex = tr.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete`,
        text: `You are about to delete "${tr.email}"`,
        accept: this.deleteRecord,
        acceptText: "Delete",
      });
    },
    deleteRecord() {
      let id = this.deleteIndex;
      this.$vs.loading();
      _delete(id).then(() => {
        this.$vs.loading.close();
        this.users = this.users.filter((p) => p.id != id);
        this.deleteIndex = -1
      });
    },

    getSubusers(page = 1) {
      this.$vs.loading();
      if(this.searchQuery) {
        _filter({data: this.searchQuery}).then((response) => {
              this.$vs.loading.close();
            this.users = response.data.obj.users
        })
      }
      else {

        _sub_users(this.current_company, page)
          .then((response) => {
            this.$vs.loading.close();
            this.users = response.data.obj.users.data;
            this.total_items = response.data.obj.users.total;
            this.items_per_page = response.data.obj.users.per_page;
            this.total_pages = response.data.obj.users.last_page;
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          });
      }
    },

    clearFields() {
      console.log(this.permission_list);
      this.email = "";
      this.password = "";
      this.selectedPermission = [];
      this.permission_list = JSON.parse(JSON.stringify(this.original_permissions));
      this.edited_permission_list = [];
      this.editedRow = "";

    },
    handleCatch(error) {
      this.$vs.notify({
        text: error.message,
        iconPack: "feather",
        icon: "icon-cross-circle",
        color: "danger",
      });
    },
  },
};
</script>

<style lang="css" scoped>
.custom-display {
  display: flex;
  justify-content: space-between;
}
.form > h4 {
  margin-bottom: 20px;
}

.form > div,
#treeview {
  display: inline-block;
  vertical-align: top;
}

.selected-container {
  padding: 20px;
  margin-left: 24px;
  background-color: rgba(191, 191, 191, 0.15);
  font-size: 115%;
  font-weight: bold;
}

#selected-permission_list {
  margin-top: 20px;
}

.dx-list-item-content {
  padding-left: 0;
}

.options {
  padding: 20px;
  background-color: rgba(191, 191, 191, 0.15);
  margin-top: 20px;
  box-sizing: border-box;
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  width: 24%;
  display: inline-block;
  margin-top: 10px;
  margin-right: 9px;
  box-sizing: border-box;
}

.recursive-option {
  padding-left: 10px;
}

.option:last-of-type {
  margin-right: 0px;
}
</style>
